import React from "react";
import Seo from "../../components/seo/seo";
import hireLaravelDetails from "../../constant/hires/laravel-developer.json";
import HireDeveloperDetails from "../../components/hire-developer-details/HireDeveloperDetails";

const breadcrumbList = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "InfyOm",
      item: "https://infyom.com",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Services",
      item: "https://infyom.com/services",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Hire Laravel Developers",
      item: "https://infyom.com/services/hire-laravel-developers",
    },
  ],
};

const HireLaravelDevelopers = () => {
  const laravelDeveloperProps = {
    title: hireLaravelDetails.title,
    description: hireLaravelDetails.description,
    developmentServices: hireLaravelDetails.developmentServices,
    whyHireInfyOm: hireLaravelDetails.whyHireInfyOm,
    hireDedicatedDevelopers: hireLaravelDetails.hireDedicatedDevelopers,
    footerText: hireLaravelDetails.footerText,
    dropdownName: hireLaravelDetails.dropdownName,
  };

  return (
    <>
      <Seo
        title={hireLaravelDetails.seoTitle}
        description="Hire expert Laravel developers from InfyOm, skilled in API & package integration, Eloquent ORM, MVC, migrations, testing, optimization & support."
        breadcrumbList={breadcrumbList}
      />
      <HireDeveloperDetails {...laravelDeveloperProps} />
    </>
  );
};

export default HireLaravelDevelopers;
